import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import InfoText from '../../atoms/InfoText';

export default function BiddingPostBreadcrumbs() {
  const { t } = useTranslation();
  const location = useLocation();
  const isDisliked = location.pathname.startsWith('/disliked-jobs');

  return (
    <div
      className="flex items-center gap-1.5 text-sm"
      data-testid="bidding-post-breadcrumbs"
    >
      <Link
        to="/"
        className="hover:text-light-text-primary dark:hover:text-dark-text-primary transition-colors"
        data-testid="bidding-post-breadcrumb-dashboard-link"
      >
        <InfoText
          text={t('biddingPosts.breadcrumbDashboard')}
          className="!text-light-text-placeholder dark:!text-dark-text-placeholder hover:!text-light-text-primary dark:hover:!text-dark-text-primary cursor-pointer"
        />
      </Link>
      <InfoText
        text="/"
        className="!text-light-text-placeholder dark:!text-dark-text-placeholder"
      />
      <Link
        to={isDisliked ? '/disliked-jobs' : '/bidding-posts'}
        className="hover:text-light-text-primary dark:hover:text-dark-text-primary transition-colors"
        data-testid="bidding-post-breadcrumb-all-posts-link"
      >
        <InfoText
          text={isDisliked ? t('biddingPosts.dislikedPosts') : t('biddingPosts.breadcrumbAllPosts')}
          className="!text-light-text-placeholder dark:!text-dark-text-placeholder hover:!text-light-text-primary dark:hover:!text-dark-text-primary cursor-pointer"
        />
      </Link>
      <InfoText
        text="/"
        className="!text-light-text-placeholder dark:!text-dark-text-placeholder"
      />
      <InfoText
        text={t('biddingPosts.breadcrumbPostDetails')}
        className="!text-light-text-primary dark:!text-dark-text-primary !font-medium"
        data-testid="bidding-post-breadcrumb-active"
      />
    </div>
  );
}
